import { render } from "./createPublicStepClientResponsibleLegal.vue?vue&type=template&id=301bfc85&scoped=true"
import script from "./createPublicStepClientResponsibleLegal.vue?vue&type=script&lang=js"
export * from "./createPublicStepClientResponsibleLegal.vue?vue&type=script&lang=js"

import "./createPublicStepClientResponsibleLegal.vue?vue&type=style&index=0&id=301bfc85&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-301bfc85"]])

export default __exports__